/* eslint no-unused-vars: 0 */
import React from 'react'
import moment from 'moment'
import styles from './PatientDetails.module.scss'
import EcgCanvas from './EcgCanvas'

const ECGVisualization = ({ ecgData, ecgSkipCount, setEcgSkipCount, ecg }) => {
  // Use ecgSkipCount to determine which ECG record to display
  const currentEcgIndex = ecgSkipCount
  const currentEcg = ecg[currentEcgIndex]?.resource
  const { component } = currentEcg || { component: [] }

  const heartRate =
    component.find((c) => c.code.coding[0].code === '8867-4')?.valueQuantity
      ?.value || 'N/A'
  const pvcCount =
    component.find((c) => c.code.coding[0].code === '4464-2')?.valueQuantity
      ?.value || 'N/A'
  const qrsDuration =
    component.find((c) => c.code.coding[0].code === '10378-9')?.valueQuantity
      ?.value || 'N/A'
  const qtInterval =
    component.find((c) => c.code.coding[0].code === '10376-3')?.valueQuantity
      ?.value || 'N/A'
  const qtcInterval =
    component.find((c) => c.code.coding[0].code === '10377-1')?.valueQuantity
      ?.value || 'N/A'
  const stSegment =
    component.find((c) => c.code.coding[0].code === '131330')?.valueQuantity
      ?.value || 'N/A'
  const heartRateInterval = component.find(
    (c) => c.code.coding[0].code === '80404-7'
  )?.valueSampledData?.data

  // Calculate heart rate variability metrics if data is available
  let rr = []
  let mean = 0
  let sdnn = 0
  let rmssd = 0
  let pnn50 = 0
  if (heartRateInterval) {
    rr = heartRateInterval
      ?.split(' ')
      .map(Number)
      .filter((bpm) => bpm !== 0)
      .map((bpm) => Math.round(60000 / bpm))

    if (rr.length > 0) {
      mean = rr.reduce((sum, val) => sum + val, 0) / rr.length
      sdnn = Math.sqrt(
        rr.reduce((sum, val) => sum + Math.pow(val - mean, 2), 0) /
          (rr.length - 1 || 1) // avoid division by zero
      )

      // RMSSD: Root mean square of successive differences
      const rrDiffs = rr.slice(1).map((val, i) => val - rr[i])
      rmssd =
        rrDiffs.length > 0
          ? Math.sqrt(
            rrDiffs.reduce((sum, d) => sum + d * d, 0) / rrDiffs.length
          )
          : 0

      // pNN50: % of successive RR differences > 50 ms
      const nn50 = rrDiffs.filter((d) => Math.abs(d) > 50).length
      pnn50 = rrDiffs.length > 0 ? (nn50 / rrDiffs.length) * 100 : 0
    }
  }

  return (
    <div className={`${styles.card} ${styles.ecg}`}>
      <div>
        <button
          className={styles['btn--primary']}
          disabled={ecgSkipCount === ecg.length - 1}
          onClick={() => setEcgSkipCount(ecgSkipCount + 1)}
        >
          Previous
        </button>
        <button
          className={styles['btn--primary']}
          disabled={ecgSkipCount === 0}
          onClick={() => setEcgSkipCount(ecgSkipCount - 1)}
        >
          Next
        </button>
      </div>
      {ecgData?.length > 0 && currentEcg && (
        <>
          <div className={styles.card__header}>
            {`ECG from ${moment(currentEcg.effectiveDateTime).format(
              'MMM Do YYYY, h:mm a'
            )}`}
          </div>
        </>
      )}
      <div className={styles.card__content}>
        <EcgCanvas ecgData={ecgData} />
      </div>
      <div className={styles.card__content}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '18px' }}>
          <span>Heart Rate: {heartRate}</span>
          <span>PVC Count: {pvcCount}</span>
          <span>QRS Duration: {qrsDuration}</span>
          <span>QT Interval: {qtInterval}</span>
          <span>QTC Interval: {qtcInterval}</span>
          <span>ST Segment: {stSegment}</span>
        </div>
      </div>
    </div>
  )
}

export default ECGVisualization
